import React from 'react';

const Vue_Template_Refs = () => {
  return (
    <div>
      <h1>Vue_Template_Refs Component</h1>
      <p>This is the Vue_Template_Refs tutorial page.</p>
    </div>
  );
}

export default Vue_Template_Refs;
